module.exports = __webpack_public_path__ + "static/img/3.9e96f0e1.png";